module.exports = __webpack_public_path__ + "img/67.8271fe40.png";